import React, { Component } from 'react'
import { reduxForm, Field, change } from 'redux-form'
import { connect } from 'react-redux'
import { bindActionCreators } from 'redux'

import Row from '../../../common/layout/row'
import LabelAndInput from '../../../common/form/LabelAndInput'
import { init, create, update, getList, showUpdate, showCreate, remove, toggleActive, duplicate, normalizeMinResult } from '../duck/crashPrompt.duck'
import If from '../../../common/operator/If'
import Table from '../../../common/layout/Table'
import Content from '../../../common/template/Content'

const TextAreaField = ({ input, label, rows, placeholder }) => (
    <div className='form-group' style={{ width: '100%', padding: '0 15px' }}>
        <label style={{ fontWeight: 600 }}>{label}</label>
        <textarea
            className='form-control'
            rows={rows || 5}
            placeholder={placeholder}
            {...input}
        />
    </div>
)

const ActiveSelect = ({ input, label }) => (
    <div className='form-group' style={{ padding: '0 15px' }}>
        <label style={{ fontWeight: 600 }}>{label}</label>
        <select className='form-control' {...input} value={input.value === '' || input.value == null ? 1 : input.value}>
            <option value={1}>Ativo</option>
            <option value={0}>Inativo</option>
        </select>
    </div>
)

class FormCrashPrompt extends Component {
    componentWillMount() {
        if (this.props.userId != null) {
            this.props.getList()
        }
    }

    componentDidUpdate(prevProps) {
        if (this.props.userId != null && prevProps.userId == null) {
            this.props.getList()
        }
    }

    onSubmit = (values) => {
        if (values.id) {
            this.props.update(values)
        } else {
            this.props.create(values)
        }
    }

    formatSchedules = (schedules) => {
        let rows = schedules
        if (typeof schedules === 'string') {
            try { rows = JSON.parse(schedules) } catch (e) { return schedules }
        }
        if (!Array.isArray(rows) || !rows.length) return '—'
        return rows.map((r) => `${r.at || r.start} → ${r.start}-${r.end}${r.label ? ` (${r.label})` : ''}`).join(' | ')
    }

    render() {
        return (
            <>
                <If test={this.props.show === 'form'}>
                    <Content>
                        <form onSubmit={this.props.handleSubmit(this.onSubmit)}>
                            <Row>
                                <Field name='title' component={LabelAndInput} readOnly={false} forceToShow
                                    label='Título' cols='12 3' placeholder='Ex.: Padrão' error={this.props.errors} />
                                <Field name='min_result' type='number' step='any' min='1.01' component={LabelAndInput} readOnly={false} forceToShow
                                    label='Resultado mínimo (>=)' cols='12 2' placeholder='2.00' error={this.props.errors}
                                    title='Crash mínimo que conta como sucesso nos sinais deste prompt. Novos sinais herdam este valor.' />
                                <Field name='history_days' type='number' step='1' min='1' max='90' component={LabelAndInput} readOnly={false} forceToShow
                                    label='Intervalo de dados (dias)' cols='12 2' placeholder='7' error={this.props.errors}
                                    title='Quantos dias de resultados e sinais win/lose entram na estatística enviada à IA. Padrão: 7. Máx: 90.' />
                                <div className='col-xs-12 col-sm-2'>
                                    <Field name='active' component={ActiveSelect} label='Status' />
                                </div>
                            </Row>
                            <Row>
                                <Field name='system_prompt' component={TextAreaField}
                                    label='System prompt' rows={4}
                                    placeholder='Mensagem de sistema enviada à IA' />
                            </Row>
                            <Row>
                                <Field name='instruction' component={TextAreaField}
                                    label='Instrução (user)' rows={5}
                                    placeholder='Instrução principal do cálculo / escolha do horário' />
                            </Row>
                            <Row>
                                <Field name='schedules_text' component={TextAreaField}
                                    label='Horários de execução (uma linha: execução,início_janela,fim_janela,rótulo)'
                                    rows={4}
                                    placeholder={'08:00,08:00,12:59,manhã\n13:00,13:00,17:59,tarde'} />
                            </Row>
                            <Row>
                                <button type='submit' className='btn btn-primary'>Salvar</button>
                                <button type='button' className='btn btn-default' onClick={this.props.init}>Cancelar</button>
                            </Row>
                        </form>
                    </Content>
                </If>
                <If test={this.props.show === 'list'}>
                    <button className='btn btn-primary' onClick={this.props.showCreate}>Adicionar</button>
                    <br /><br />
                </If>
                <Table
                    body={[...this.props.list]}
                    labelMobile='title'
                    actions={{
                        update: this.props.showUpdate,
                        remove: this.props.remove,
                        duplicate: {
                            title: 'Duplicar',
                            icon: 'fa fa-copy',
                            onClick: (row) => this.props.duplicate(row),
                        },
                    }}
                    attributes={{
                        title: 'Título',
                        min_result: {
                            title: 'Mínimo',
                            callback: (val) => `>= ${normalizeMinResult(val)}x`,
                        },
                        history_days: {
                            title: 'Dias',
                            callback: (val) => {
                                const n = Math.floor(Number(val))
                                return Number.isFinite(n) && n >= 1 ? `${n}d` : '7d'
                            },
                        },
                        schedules: {
                            title: 'Horários',
                            callback: (val) => this.formatSchedules(val),
                        },
                        accuracy: {
                            title: 'Acuracidade',
                            callback: (val, row) => {
                                if (val == null || val === '') {
                                    const decided = row && row.accuracy_decided
                                    return decided ? '0%' : '—'
                                }
                                const n = Number(val)
                                if (!Number.isFinite(n)) return '—'
                                const decided = row && row.accuracy_decided
                                const wins = row && row.accuracy_wins
                                if (decided > 0 && wins != null) {
                                    return `${n}% (${wins}/${decided})`
                                }
                                return `${n}%`
                            },
                        },
                        win_streak: {
                            title: 'Win Consecutivas',
                            // O valor vem sempre da linha: 0 chega como '' na célula.
                            callback: (val, row) => {
                                const n = Number(row && row.win_streak)
                                if (!Number.isFinite(n)) return '—'
                                if (!(row && row.accuracy_decided)) return '—'
                                return (
                                    <b style={{ color: n > 0 ? '#2e7d32' : '#757575' }}>
                                        {n > 0 ? `${n} seguidas` : '0'}
                                    </b>
                                )
                            },
                        },
                        active: {
                            title: 'Ativo',
                            callback: (val, row) => (
                                <button
                                    type='button'
                                    className={`btn btn-xs ${Number(val) === 1 ? 'btn-success' : 'btn-default'}`}
                                    onClick={() => this.props.toggleActive(row)}
                                >
                                    {Number(val) === 1 ? 'Sim' : 'Não'}
                                </button>
                            ),
                        },
                    }}
                />
            </>
        )
    }
}

FormCrashPrompt = reduxForm({ form: 'crashPromptForm', destroyOnUnmount: false })(FormCrashPrompt)
const mapStateToProps = state => ({
    list: state.crashPrompt ? state.crashPrompt.list : [],
    show: state.crashPrompt ? state.crashPrompt.show : 'list',
    errors: state.crashPrompt ? state.crashPrompt.errors : {},
    userId: state.auth.user ? state.auth.user.id : null,
})
const mapDispatchToProps = dispatch => bindActionCreators({
    init, create, update, getList, showUpdate, showCreate, remove, toggleActive, duplicate, change
}, dispatch)
export default connect(mapStateToProps, mapDispatchToProps)(FormCrashPrompt)
